import api from '../api/axios';
import { Zone } from '../types/zones';

export const getAllZones = async (): Promise<Zone[]> => {
  try {
    const response = await api.get(`${import.meta.env.VITE_API_BASE_URL}/zones`);
    if (response.status !== 200) throw new Error('Error fetching roles');
    return response.data;
  } catch (error) {
    console.error('Error fetching all zones:', error);
    throw error;
  }
};
